<template>
  <div class="model-train-data-container" ref="">
    <fixed-header-table :fixed="figureSummary.figurePreview.basic.value != null && figureSummary.figurePreview.basic.value.length > 0" ref="fixedHeaderTable">
      <tr slot="header">
        <th style="flex-grow: 0; justify-content: center;">予測<br>対象</th>
        <th style="flex-grow: 0; justify-content: center;">分析<br>対象</th>
        <th style="flex-grow: 0; min-width: 420px;"><div style="display: flex; align-items: center;">データ項目</div></th>
        <th style="flex-grow: 0; min-width: 180px; max-width: 180px;"><div style="display: flex; align-items: center;">タイプ</div></th>
        <th><div style="display: flex; align-items: center;">値（1行目）</div></th>
        <th><div style="display: flex; align-items: center;">ユニーク数</div></th>
        <th><div style="display: flex; align-items: center;">オープンデータ追加</div></th>
        <th><div style="display: flex; align-items: center;">備考</div></th>
      </tr>

      <template v-for="basic in originalColumns">
        <tr :class="{ 'no-use-column': (selectedRadio !== basic.column || isUnsModel) && !basic.use }">
          <td :class="{ 'no-use-field': isUnsModel }" style="flex-grow: 0; justify-content: center;"><el-radio class="label-hide" name="y-name-rdo" v-model="selectedRadio" :label="basic.column" @change="onChangeYName" :disabled="!isUsableForYName(basic.column)"></el-radio></td>
          <td style="flex-grow: 0; justify-content: center;"><el-checkbox class="label-hide" v-model="basic.use" :key="basic.column + '__use'" :disabled="!isUnsModel && selectedRadio === basic.column" @change="onChangeXUse(basic)"></el-checkbox></td>
          <td style="flex-grow: 0; min-width: 420px;">{{basic.column}}</td>
          <td style="flex-grow: 0; min-width: 180px; max-width: 180px;">
            <el-select v-model="getCurrentXType(basic.column).type" placeholder="" v-if="isTransformable(basic)" @change="$forceUpdate()" @visible-change="onSelectVisibleChange">
              <el-option v-for="item in getAvailableXTypes(basic)"
                         :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <div v-if="!isTransformable(basic)" v-text="getXTypeByLabel(basic.xType).label"></div>
          </td>
          <td><span class="td-wrapper">{{basic.firstVal | number_format('-')}}</span></td>
          <td>{{basic.uniqueVals | number_format('-')}}</td>
          <td :class="{ 'can-add-data-collection': canAddDataCollection(basic.column) }">
            <span v-if="canAddDataCollection(basic.column)"><i class="el-icon-circle-plus data-collection-add-button" @click="onClickAddDataCollection(basic)"></i></span>
          </td>
          <td>
            <span  v-if="isTransformable(basic)"><tooltip-icon placement="top" :content="'タイプを変更できます'" icon="el-icon-refresh"></tooltip-icon></span>
            <template v-if="basic.info && basic.info !== {}" v-for="infoCode in Object.keys(basic.info)">
              <span v-if="/^2\d{2}$/.test(infoCode)"><tooltip-icon placement="top" :content="getInfoMessage(infoCode)" icon="el-icon-info"></tooltip-icon></span>
              <span v-else-if="/^[34]\d{2}$/.test(infoCode)"><tooltip-icon placement="top" :content="getInfoMessage(infoCode)" icon="el-icon-warning"></tooltip-icon></span>
            </template>
          </td>
        </tr>

        <template v-if="hasDataCollection(basic.column)">
        <!--display open header row -->
          <template v-for="data in dataCollectionInfo(basic.column)">
            <tr class="data-collection-index" @click="onClickToggleDataCollection(getDataCollectionPrefix(basic.column, data.dataCollectionId , data.categoryId))">
              <th style="flex-grow: 0; justify-content: center;"></th>
              <th colspan="3" style="flex-grow: 0;">
                <i :class="[visibleDataCollection[getDataCollectionPrefix(basic.column, data.dataCollectionId , data.categoryId)] ? 'el-icon-arrow-up' : 'el-icon-arrow-down' , 'accordion-button']"></i>&nbsp;
                <span v-text="getDataCollectionHeaderName(data.dataCollectionId, data.categoryId)"></span>
              </th>
              <th></th>
              <th></th>
              <th>
                <span><i class="el-icon-circle-close data-collection-close-button" @click.stop="onClickDeleteDataCollection(basic, data.dataCollectionId, data.categoryId)"></i></span>
              </th>
              <th>
                <span><tooltip-icon placement="top" content='オープンデータです' icon="el-icon-info"></tooltip-icon></span>
              </th>
            </tr>
            <!--display open row -->
            <tr v-for="dataCollectionValue in relatedDataCollection(basic.column,data.dataCollectionId, data.categoryId)"
                v-show="visibleDataCollection[getDataCollectionPrefix(basic.column, data.dataCollectionId , data.categoryId)]"
                class='data-collection' :class="{ 'no-use-column': selectedRadio !== dataCollectionValue.column && !dataCollectionValue.use }"
            >
              <td style="flex-grow: 0; justify-content: center;"></td>
              <td style="flex-grow: 0; justify-content: center;">
                <el-checkbox class="label-hide" v-model="dataCollectionValue.use" :key="dataCollectionValue.column + '__use'" @change="onChangeXUse(dataCollectionValue.column, dataCollectionValue.use)"></el-checkbox>
              </td>
              <td style="flex-grow: 0; min-width: 420px;">{{getSummaryDisplayDataCollectionName(dataCollectionValue.column)}}</td>
              <td style="flex-grow: 0; min-width: 180px; max-width: 180px;"><div v-text="getXTypeByLabel(getCurrentXType(dataCollectionValue.column).type).label"></div></td>
              <td><span class="td-wrapper">{{dataCollectionValue.firstVal | number_format('-')}}</span></td>
              <td>{{dataCollectionValue.uniqueVals | number_format('-')}}</td>
              <td></td>
              <td>
                <template v-if="dataCollectionValue.info && dataCollectionValue.info !== {}" v-for="infoCode in Object.keys(dataCollectionValue.info)">
                  <span v-if="/^2\d{2}$/.test(infoCode)"><tooltip-icon placement="top" :content="getInfoMessage(infoCode)" icon="el-icon-info"></tooltip-icon></span>
                  <span v-else-if="/^[34]\d{2}$/.test(infoCode)"><tooltip-icon placement="top" :content="getInfoMessage(infoCode)" icon="el-icon-warning"></tooltip-icon></span>
                 </template>
              </td>
            </tr>
          </template>
        </template>
      </template>
    </fixed-header-table>

    <el-dialog custom-class="figure-detail-dialog dialog-size-large tab-dialog" v-if="visibleFigureDetail != null && visibleFigureDetail"
               title="学習データのサマリ" append-to-body="true" :visible="visibleFigureDetail"
               :top="0" :modal="false"
               @close="visibleFigureDetail=false">
        <figure-container v-if="figureDetail" :categoryId="modelInfo.categoryId" :figure="figureDetail" :yName="modelInfo.yName" :dataCollections="modelInfo.dataCollections"></figure-container>
    </el-dialog>

    <data-collection-select v-if="visibleDataCollectionSelect != null && visibleDataCollectionSelect"
                        :visible="visibleDataCollectionSelect"
                        :model-data-collection-usage="getSelectedColumnDataCollection()"
                        :method="$route.meta.trainType"
                        :ds="modelInfo.ds"
                        :model-id="modelInfo.modelId"
                        :possibility="getPossibility(selectedColumn.column)"
                        :selected-column="selectedColumn"
                        @close="visibleDataCollectionSelect=false"
                        @select="onSelectDataCollection">
    </data-collection-select>

  </div>

</template>

<script lang="js">
import BaseTrainView from './base'
import axios from 'axios'
import WebApiClient from '../../../api/web'
import {Code} from '../../../api/base'
import CommonUtil from '../../../utils/common'
import FigureCmp from '../../../components/model/figure/figure.vue'
import DataCollectionSelectCmp from '../../../components/model/figure/dialogs/data-collection-select.vue'
import {X_TYPE_DEFINE} from '../../../defines/model/model'
import {
  DATA_COLLECTION_DEFINES,
  TYPE_ESTIMATE_THRESHOLD
} from '../../../defines/data-collection'
import Messages from '../../../utils/messages'
import MessageBox from '../../../utils/message-box'
import LoadingManager from '../../../utils/loading'
import {Category} from '../../../defines/const'

export default {
  name: 'ModelTrainDataView',
  mixins: [BaseTrainView],
  components: {
    'figure-container': FigureCmp,
    'data-collection-select': DataCollectionSelectCmp
  },
  data () {
    return {
      figureSummary: {
        figureId: null,
        yName: null,
        figurePreview: {
          basic: {
            value: []
          }
        }
      },
      figureDetail: null,
      visibleFigureDetail: false,
      visibleDataCollectionSelect: false,
      visibleDataCollection: {},
      currentDataCollectionList: {},
      dataCollectionPrefixes: [],
      selectedRadio: '',
      selectedColumnPreviewBasicValue: null
    }
  },
  created () {
    const trainView = this.getTrainView()
    trainView.$on('figure-detail', this.onClickFigureDetail)
    trainView.$on('model-train', this.onClickTrain)
  },
  destroyed () {
    const trainView = this.getTrainView()
    trainView.$off('figure-detail', this.onClickFigureDetail)
    trainView.$off('model-train', this.onClickTrain)
  },
  computed: {
    originalColumns () {
      return this.getNotAdditionalDataCollectionColumns()
    },

    isUnsModel () {
      return this.modelInfo.categoryId === 'UNS'
    }
  },
  methods: {
    initialize () {
      this.setDataCollectionPrefixes()
      const joinDsNames = this.modelInfo.ds.uploadFiles.filter(uploadFile => uploadFile.isJoined !== true)
        .map(uploadFile => uploadFile.dsName)

      let subsetParams = []
      let subsetPromises = []
      if (CommonUtil.isNotEmpty(this.modelInfo.dataCollections) && CommonUtil.isNotEmpty(joinDsNames)) {
        subsetParams = this.getModelInfoDataCollectionSubsetParams()
        subsetPromises = subsetParams.map(param => WebApiClient.getDataCollectionSubset(this, param.dataCollectionId,
          { categoryId: param.categoryId }))
      }

      Promise.all(subsetPromises).then(responses => {
        let subsetInfo = []
        if (responses.length > 0) {
          responses.forEach((response, i) => {
            subsetInfo.push({
              dataCollectionId: subsetParams[i].dataCollectionId,
              categoryId: subsetParams[i].categoryId,
              subset: response.data.result.subsets
            })
          })
          return Promise.resolve(subsetInfo)
        }
      }).then(subsetInfo => {
        // make promises
        const initialJoinPromises = this.initialDataCollectionJoinPromises(joinDsNames, subsetInfo)
        let possibilitiesPromise = []
        if (CommonUtil.isEmpty(this.modelInfo.possibilities)) {
          const dsName = CommonUtil.isNotEmpty(this.modelInfo.ds.dsName)
            ? this.modelInfo.ds.dsName
            : this.modelInfo.ds.uploadFiles[0].dsName
          possibilitiesPromise.push(WebApiClient.getDataCollectionPossibilities(this, dsName))
        }

        const promises = possibilitiesPromise.concat(initialJoinPromises)

        return Promise.all(promises).then(responses => {
          if (CommonUtil.isNotEmpty(possibilitiesPromise)) {
            const possibilitiesResponse = responses.pop()
            this.modelInfo.possibilities = possibilitiesResponse.data.result.possibilities
          }

          const joinResponses = CommonUtil.isNotEmpty(responses) ? responses[0] : []
          joinResponses.forEach((response, i) => {
            const targetFile = this.modelInfo.ds.uploadFiles.filter(
              uploadFile => uploadFile.dsName === joinDsNames[i])[0]
            targetFile.dsName = response.data.result.dsName
            targetFile.fileName = response.data.result.fileName
          })

          if (CommonUtil.isNotEmpty(joinResponses)) {
            this.modelInfo.ds.dsName = null
          }

        })
      }).then(() => {
        this.loadFigureSummary()
      }
      ).catch(() => {
        this.getTrainView().prevRoute()
      })
      this.initializeForDoTrain()
    },
    hasChangeFigure (figure) {
      // check dsName
      if (this.hasChangeDsName(figure)) {
        return true
      }

      // check yName. skip check when UNS because UNS doesn't specify yName.
      if (this.modelInfo.categoryId !== Category.UNS) {
        if (this.hasChangeYName(figure)) {
          return true
        }
      }

      // check xType
      return this.hasChangeXType(figure)
    },

    hasChangeYName (figure) {
      return (this.modelInfo.yName !== figure.yName)
    },

    hasChangeXType (figure) {
      for (const row of figure.figurePreview.basic.value) {
        const column = row.column
        const xType = this.modelInfo.xType.filter(value => value.name === column)
        if (CommonUtil.isNotEmpty(xType) && xType[0].type !== row.xType) {
          return true
        }
      }
      return false
    },

    hasChangeDsName (figure) {
      const ds = this.modelInfo.ds
      const modelDsName = CommonUtil.isNotEmpty(ds.dsName) ? ds.dsName : ds.uploadFiles[0].dsName
      return (modelDsName !== figure.dsName)
    },

    getInfoMessage (code) {
      const message = Messages.getMessage(`I${code}`)
      if (CommonUtil.isEmpty(message)) {
        return '-'
      } else {
        return message
      }
    },

    loadFigureSummary (cancelable = false) {
      if (CommonUtil.isNotNull(this.modelInfo.figureSummary)) {
        if (this.hasChangeXType(this.modelInfo.figureSummary)) {
          this.modelInfo.figureSummaryId = null
          this.modelInfo.figureSummary = null
        } else {
          this.handleFigureSummaryResponse(this.modelInfo.figureSummary, true)
          return
        }
      }

      if (this.modelInfo.figureSummaryId) {
        WebApiClient.getFigure(this, this.modelInfo.figureSummaryId).then(response => {
          if (response.data.code === Code.SUCCESS) {
            this.modelInfo.figureSummary = response.data.result
            this.loadFigureSummary()
          }
        })
      } else {
        WebApiClient.postFigures(this, this.buildFigureParam(false), cancelable).then(response => {
          if (response.data.code === Code.SUCCESS) {
            this.handleFigureSummaryResponse(response.data.result)

            if (this.modelInfo.ds.uploadFiles.filter(uploadFile => uploadFile.isJoined !== true).length > 0 &&
                CommonUtil.isNotEmpty(this.modelInfo.dataCollections)) {
              return WebApiClient.getUploadFiles(this, this.figureSummary.dsName)
            } else {
              this.getTrainView().saveModelInfo()
            }
          } else {
            this.getTrainView().prevRoute()
          }
        }).then(response => {
          this.modelInfo.ds.uploadFiles = response.data.result.uploadFiles
          this.modelInfo.ds.uploadFiles.forEach(uploadFile => { uploadFile.isJoined = true })
          this.getTrainView().saveModelInfo()
          this.setDataCollectionPrefixes()
        }).catch(() => {})
      }
    },

    canAddDataCollection (columnName) {
      if (CommonUtil.isEmpty(this.modelInfo.possibilities)) {
        return false
      } else {
        const typeInfo = this.modelInfo.possibilities.filter(column => column.name === columnName)[0]

        let canAdd = false
        Object.keys(typeInfo).forEach(key => {
          if (key !== 'name') {
            if (typeInfo[key] > TYPE_ESTIMATE_THRESHOLD) {
              canAdd = true
            }
          }
        })
        return canAdd
      }
    },

    getPossibility (name) {
      return this.modelInfo.possibilities.filter(column => column.name === name)[0]
    },

    hasDataCollection (columnName) {
      if (CommonUtil.isEmpty(this.modelInfo.dataCollections)) {
        return false
      } else {
        for (let data of this.modelInfo.dataCollections) {
          if (data.target === columnName) {
            return true
          }
        }
      }
      return false
    },

    dataCollectionInfo (columnName) {
      let result = []
      if (CommonUtil.isEmpty(this.modelInfo.dataCollections)) {
        return false
      } else {
        for (let data of this.modelInfo.dataCollections) {
          if (data.target === columnName) {
            result.push(data)
          }
        }
      }
      return result
    },

    getDataCollectionDef (dataCollectionId, categoryId = null) {
      if (CommonUtil.isNotEmpty(categoryId)) {
        return DATA_COLLECTION_DEFINES.filter(
          data => data.dataCollectionId === dataCollectionId && data.categoryId === categoryId)[0]
      } else {
        return DATA_COLLECTION_DEFINES.filter(data => data.dataCollectionId === dataCollectionId)[0]
      }
    },

    getDataCollectionHeaderName (dataCollectionId, categoryId = null) {
      const DataCollectionDef = this.getDataCollectionDef(dataCollectionId, categoryId)

      if (CommonUtil.isNotEmpty(DataCollectionDef.categoryName)) {
        return DataCollectionDef.dataCollectionName + '_' + DataCollectionDef.categoryName
      } else {
        return DataCollectionDef.dataCollectionName
      }
    },

    getAdditionalDataCollectionColumns () {
      const dataCollection = this.modelInfo.dataCollections
      if (CommonUtil.isEmpty(dataCollection)) {
        return []
      } else {
        return dataCollection.map(data => data.columns).reduce((array, column) => array.concat(column))
      }
    },
    getNotAdditionalDataCollectionColumns () {
      const dataCollectionColumns = this.getAdditionalDataCollectionColumns()
      return this.figureSummary.figurePreview.basic.value.filter(
        value => dataCollectionColumns.indexOf(value.column) === -1)
    },

    relatedDataCollection (columnName, dataCollectionId, categoryId) {
      const relatedData = this.modelInfo.dataCollections.filter(
        modelData => modelData.target === columnName && modelData.dataCollectionId === dataCollectionId &&
            modelData.categoryId === categoryId)[0]
      return this.figureSummary.figurePreview.basic.value.filter(
        value => relatedData.columns.indexOf(value.column) !== -1)
    },

    onClickAddDataCollection (column) {
      this.selectedColumn = column
      this.visibleDataCollectionSelect = true
    },

    getJoinedDataCollection (target, dataCollectionId, categoryId) {
      const joinedDataCollection = this.modelInfo.dataCollections.filter(modelData =>
        modelData.target === target &&
          modelData.dataCollectionId === dataCollectionId &&
          modelData.categoryId === categoryId
      )
      return CommonUtil.isNotEmpty(joinedDataCollection) ? joinedDataCollection[0] : null
    },

    onClickDeleteDataCollection (column, dataCollectionId, categoryId = null) {
      this.selectedColumn = column
      const columnName = this.selectedColumn.column
      const displayName = this.getDataCollectionHeaderName(dataCollectionId, categoryId)

      MessageBox.confirm(this, `「${columnName}」に紐づけた${displayName}を削除してもよろしいですか？`).then(() => {
        return this.deleteDataCollection(dataCollectionId, categoryId)
      }).catch(() => {
      })

    },

    deleteDataCollection (dataCollectionId, categoryId = null) {
      const targetModelDataCollection = this.getJoinedDataCollection(this.selectedColumn.column, dataCollectionId,
        categoryId)
      const resultModelDataCollection = this.modelInfo.dataCollections.filter(
        data => data !== targetModelDataCollection)

      if (CommonUtil.isNotEmpty(resultModelDataCollection)) {
        // for keep relation of task and upload file.
        if (this.modelInfo.ds.uploadFiles.length > 1) {
          this.modelInfo.ds.dsName = null
        }

        const dropColumns = targetModelDataCollection.columns
        const targetDsNames = this.modelInfo.ds.uploadFiles.map(uploadFile => uploadFile.dsName)

        const dropPromises = this.buildDsDsDropColumnsPromises(targetDsNames, dropColumns)
        return Promise.all(dropPromises).then(responses => {
          this.handleDsDropColumnsResponses(targetDsNames, dropColumns, responses)
          this.modelInfo.dataCollections = resultModelDataCollection
          this.setDataCollectionPrefixes()
          this.$forceUpdate()
        })
      } else {
        return this.revertOriginalDsInfo()
      }
    },

    getSelectedColumnDataCollection () {
      if (CommonUtil.isNotEmpty(this.modelInfo.dataCollections)) {
        const dataCollection = this.modelInfo.dataCollections.filter(
          data => data.target === this.selectedColumn.column)
        return CommonUtil.isNotEmpty(dataCollection) ? dataCollection : null
      } else {
        return null
      }
    },

    onSelectDataCollection (selectedDataCollection, selectedType) {
      const oldDs = this.deepCopyDs(this.modelInfo.ds)
      const oldXType = Object.assign([], this.modelInfo.xType)
      const oldDataCollectionColumn = this.getAdditionalDataCollectionColumns()
      const oldModelInfoDataCollection = this.deepCopyDataCollections(this.modelInfo.dataCollections)
      const oldFigurePreviewBasicValue = Object.assign([], this.figureSummary.figurePreview.basic.value)

      const targetColumn = this.selectedColumn

      // update data collection info.
      this.updateModelInfoDataCollection(targetColumn, selectedDataCollection, selectedType)
      const additionalHeader = this.modelInfo.xType.map(xType => xType.name)

      const joinParams = this.buildDataCollectionJoinParam(selectedDataCollection, selectedType,
        oldModelInfoDataCollection)

      let dropColumns = []
      const targetDataCollection = oldModelInfoDataCollection.filter(
        modelData => modelData.target === targetColumn.column)
      if (CommonUtil.isNotEmpty(targetDataCollection)) {
        const targetDataCollectionColumns = targetDataCollection.map(targetData => targetData.columns)
          .reduce((array, column) => array.concat(column))
        dropColumns = targetDataCollectionColumns.filter(column => additionalHeader.indexOf(column) === -1)
      }

      // for keeping connection of ds and multi upload file, delete old info and get merge figure/update.
      if (CommonUtil.isNotEmpty(joinParams) || CommonUtil.isNotEmpty(dropColumns)) {
        this.modelInfo.ds.dsName = null
      }
      const dropDsNames = this.modelInfo.ds.uploadFiles.map(uploadFile => uploadFile.dsName)

      let dropPromises = []
      const doDeleteAllDataCollections = oldDataCollectionColumn.filter(
        column => dropColumns.indexOf(column) === -1).length === 0

      if (CommonUtil.isNotEmpty(dropColumns)) {
        if (doDeleteAllDataCollections) {
          this.revertOriginalDsInfo(oldDataCollectionColumn)
        } else {
          dropPromises = this.buildDsDsDropColumnsPromises(dropDsNames, dropColumns)
        }
      }

      Promise.all(dropPromises).then(responses => {
        if (dropPromises.length > 0) {
          this.handleDsDropColumnsResponses(dropDsNames, dropColumns, responses)
        }

        // make promises and handle request
        if (CommonUtil.isNotEmpty(joinParams)) {
          const dataCollectionJoinParam = {
            method: this.$route.meta.trainType,
            modelId: this.modelInfo.modelId,
            joinParam: joinParams
          }
          const joinDsNames = this.modelInfo.ds.uploadFiles.map(uploadFile => uploadFile.dsName)
          return this.buildDataCollectionJoinPromises(joinDsNames, dataCollectionJoinParam, true).then(responses => {
            if (CommonUtil.isNotEmpty(joinParams)) {
              for (let i = 0; i < responses.length; i++) {
                if (responses[i].data.code === Code.SUCCESS) {
                  this.modelInfo.ds.uploadFiles[i].dsName = responses[i].data.result.dsName
                  this.modelInfo.ds.uploadFiles[i].fileName = responses[i].data.result.fileName
                  this.modelInfo.ds.uploadFiles[i].fileSizeByte = responses[i].data.result.fileSizeByte
                } else {
                  this.alertError(responses[i].data.code)
                  return Promise.reject()
                }
              }
            }
          })
        } else {
          return Promise.resolve()
        }
      }).then(() => {
        // if nothing to join, not perform figure.
        if (CommonUtil.isEmpty(joinParams)) {
          return Promise.resolve()
        }

        return WebApiClient.postFigures(this, this.buildFigureParam(false), true).then(response => {
          if (response.data.code === Code.SUCCESS) {
            const dataCollectionColumns = this.getAdditionalDataCollectionColumns()
            const newDataCollectionColumns = dataCollectionColumns.filter(
              column => oldDataCollectionColumn.indexOf(column) === -1)
            this.handleJoinFigureSummaryResponse(response.data.result, newDataCollectionColumns)

            // update upload files info.
            return WebApiClient.getUploadFiles(this, this.figureSummary.dsName)
          } else {
            return Promise.reject()
          }
        }).then(response => {
          this.modelInfo.ds.uploadFiles = response.data.result.uploadFiles
          this.modelInfo.ds.uploadFiles.forEach(uploadFile => { uploadFile.isJoined = true })
          this.setDataCollectionPrefixes()

          // TODO 調整が上手くいってないので要修正（暫定minwidthを広めにとって対処）
          // this.$refs.fixedHeaderTable.calcColumnWidths();

          this.getTrainView().saveModelInfo()
          this.$forceUpdate()
        })
      }).catch(() => {
        this.modelInfo.ds = oldDs
        this.modelInfo.xType = oldXType
        this.modelInfo.dataCollections = oldModelInfoDataCollection
        this.figureSummary.figurePreview.basic.value = oldFigurePreviewBasicValue
        this.$forceUpdate()
      })
    },

    updateModelInfoDataCollection (targetColumn, newDataCollection, selectedType) {
      // firstly delete all xType related target column, then add current info.
      if (CommonUtil.isNotEmpty(this.modelInfo.dataCollections)) {
        const selectedColumnDataCollection = this.modelInfo.dataCollections.filter(
          data => data.target === targetColumn.column)
        selectedColumnDataCollection.forEach(modelData => {
          this.modelInfo.xType = this.modelInfo.xType.filter(xType => modelData.columns.indexOf(xType.name) === -1)
        })
      }

      // add data_collections,
      if (CommonUtil.isEmpty(this.modelInfo.dataCollections)) {
        this.modelInfo.dataCollections = []
      } else {
        // if there is old data collection info, delete before add new info.
        this.modelInfo.dataCollections = this.modelInfo.dataCollections.filter(
          modelData => modelData.target !== targetColumn.column)
      }

      let addDataCollections = []
      let modelXType = []

      newDataCollection.forEach(data => {
        // add each column.
        let subsetNames = []
        if (CommonUtil.isNotEmpty(data.subsets)) {
          subsetNames = data.subsets.filter(subset => subset.use === true).map(subset => subset.subsetName)
        }
        const prefix = this.getDataCollectionPrefix(targetColumn.column, data.dataCollectionId, data.categoryId)
        modelXType = data.xType.map(xType => ({
          name: prefix + '__' + xType.name,
          type: xType.type
        }))

        this.modelInfo.xType = this.modelInfo.xType.concat(modelXType)

        addDataCollections.push({
          target: targetColumn.column,
          type: selectedType,
          dataCollectionId: data.dataCollectionId,
          categoryId: data.categoryId,
          subsets: CommonUtil.isNotEmpty(subsetNames) ? subsetNames : null,
          columns: modelXType.map(xType => xType.name)
        })
      })
      this.modelInfo.dataCollections = this.modelInfo.dataCollections.concat(addDataCollections)
    },

    deepCopyDataCollections (dataCollections) {
      let results = []
      if (CommonUtil.isEmpty(dataCollections)) {
        return results
      }

      dataCollections.forEach(data => {
        let result = Object.assign({}, data)
        result.columns = Object.assign([], result.columns)
        result.subsets = Object.assign([], result.subsets)

        results.push(result)
      })

      return results
    },

    deepCopyDs (ds) {
      let result = Object.assign({}, ds)
      result.header = Object.assign([], result.header)
      result.uploadFiles = Object.assign([], result.uploadFiles)
      result.uploadFiles = result.uploadFiles.map(uploadFile => Object.assign({}, uploadFile))
      return result
    },

    getDataCollectionPrefix (leftOn, dataCollectionId, categoryId = null) {
      const dataCollectionDef = this.getDataCollectionDef(dataCollectionId, categoryId)

      let prefix = leftOn + '_' + dataCollectionDef.dataCollectionName
      prefix = CommonUtil.isNotEmpty(dataCollectionDef.categoryName)
        ? prefix + '_' + dataCollectionDef.categoryName
        : prefix

      return prefix
    },

    setDataCollectionPrefixes () {
      this.dataCollectionPrefixes = []

      if (CommonUtil.isNotEmpty(this.modelInfo.dataCollections)) {
        this.modelInfo.dataCollections.forEach(data => {
          const prefix = this.getDataCollectionPrefix(data.target, data.dataCollectionId, data.categoryId)
          this.dataCollectionPrefixes.push(prefix)
        })
      }
    },

    getSummaryDisplayDataCollectionName (columnName) {
      this.dataCollectionPrefixes.forEach(prefix => {
        if (columnName.startsWith(prefix + '__')) {
          columnName = columnName.replace(prefix + '__', '')
        }
      })
      return columnName
    },

    onClickToggleDataCollection (name) {
      this.visibleDataCollection[name] = !this.visibleDataCollection[name]
      this.$forceUpdate()
    },

    loadFigureDetail () {
      if (CommonUtil.isNotNull(this.modelInfo.figureDetail)) {
        if (this.hasChangeFigure(this.modelInfo.figureDetail)) {
          this.modelInfo.figureDetail = null
          this.modelInfo.figureDetailId = null
        } else {
          this.handleFigureDetailResponse(this.modelInfo.figureDetail)
          return
        }
      }

      if (this.modelInfo.figureDetailId) {
        WebApiClient.getFigure(this, this.modelInfo.figureDetailId).then(response => {
          if (response.data.code === Code.SUCCESS) {
            this.modelInfo.figureDetail = response.data.result
            this.loadFigureDetail()
          }
        })
      } else {
        WebApiClient.postFigures(this, this.buildFigureParam(true), true).then(response => {
          if (response.data.code === Code.SUCCESS) {
            this.handleFigureDetailResponse(response.data.result)
          }
        }).catch(() => {})
      }
    },

    onClickFigureDetail () {
      this.loadFigureDetail()
    },

    buildFigureParam (isDetail) {
      const xType = this.modelInfo.xType || []
      const xName = xType.map(value => value.name).filter(value => this.modelInfo.xExcept.indexOf(value) < 0)
      const ds = this.modelInfo.ds
      const figureParam = {
        dsName: CommonUtil.isNotEmpty(ds.dsName) ? [ds.dsName] : this.modelInfo.ds.uploadFiles.map(
          uploadFile => uploadFile.dsName),
        categoryId: this.modelInfo.categoryId,
        algorithmId: this.modelInfo.algorithm ? this.modelInfo.algorithm.algorithmId : null,
        yName: isDetail ? this.modelInfo.yName : null,
        xNames: xName,
        xType: xType,
        xCount: isDetail ? (this.modelInfo.xType.length - 1) : 0,
        modelId: this.modelInfo.modelId,
        skipXType: this.getAdditionalDataCollectionColumns(),
        isDetail: isDetail
      }

      return figureParam
    },

    getCurrentXType (column) {
      return this.modelInfo.xType.filter((value) => value.name === column)[0]
    },

    getXTypeByLabel (label) {
      return X_TYPE_DEFINE.filter(xType => xType.value === label)[0]
    },

    isTransformable (value) {
      const transformableTypes = value.transformableTypes || []

      // << temporary solution for time series model >>
      if (this.modelInfo.categoryId === 'TSA' && value.xType === 'time') {
        return false
      }

      return value.transformable === 1 || CommonUtil.isNotEmpty(transformableTypes)
    },
    getAvailableXTypes (value) {
      let transformableTypes = value.transformableTypes

      if (CommonUtil.isEmpty(transformableTypes)) {
        transformableTypes = (value.transformable === 1) ? ['category', 'numeric'] : [value.xType]
      }

      return X_TYPE_DEFINE.filter(xType => transformableTypes.indexOf(xType.value) !== -1)
    },

    onChangeXUse (value) {
      const column = value.column
      const use = value.use

      if (this.isUnsModel && column === this.modelInfo.yName && use === true) {
        console.log(column, use)
        const message = `「<b>${column}</b>」は集計対象として指定されています。<br>指定を解除して分析対象として選択しますか？`
        MessageBox.confirm(this, message, {dangerouslyUseHTMLString: true}
        ).then(() => {
          this.modelInfo.yName = null
          return this.updateXExcept(column, use)
        }).catch((
        ) => {
          value.use = !use
          return this.$forceUpdate()
        })
      } else {
        return this.updateXExcept(column, use)
      }
    },

    updateXExcept (column, use) {
      const existIndex = this.modelInfo.xExcept.indexOf(column)
      if (use) {
        if (existIndex >= 0) {
          this.modelInfo.xExcept.splice(existIndex, 1)
          this.$forceUpdate()
        }
      } else {
        if (existIndex < 0) {
          this.modelInfo.xExcept.push(column)
          this.$forceUpdate()
        }
      }
    },

    onChangeYName (column) {
      this.modelInfo.yName = column
    },

    handleFigureSummaryResponse (figure, load = false) {
      // non exist
      if (CommonUtil.isEmpty(this.modelInfo.xType)) {
        if (!this.isUnsModel) {
          this.modelInfo.yName = figure.yName
        }

        for (let row of figure.figurePreview.basic.value) {
          this.modelInfo.xType.push({
            name: row.column,
            type: row.xType
          })
          row.use = true
          if (CommonUtil.isNotEmpty(row.info)) {
            for (const infoCode of Object.keys(row.info)) {
              if (/^4\d{2}$/.test(infoCode)) {
                this.modelInfo.xExcept.push(row.column)
                row.use = false
                break
              }
            }
          }
        }
      } else {
        // for after drop columns browser reload.
        const columns = this.modelInfo.xType.map(x => x.name)
        let basic = figure.figurePreview.basic
        basic.value = basic.value.filter(value => columns.indexOf(value.column) >= 0)

        for (let row of basic.value) {
          row.use = this.modelInfo.xExcept.indexOf(row.column) < 0
        }

        // << temporary solution for time series model >>
        if (this.modelInfo.categoryId === 'TSA') {
          const yName = this.modelInfo.yName
          basic.value.forEach(value => {
            const xType = this.getCurrentXType(value.column)
            const canTime = value.transformable || value.transformableTypes.indexOf('time') >= 0
            if (xType.name !== yName && xType.type !== 'time' && canTime) {
              xType.type = 'time'
            }
          })
        }
      }

      const ds = this.modelInfo.ds
      if (load === false && ds.uploadFiles.length > 1) {
        ds.dsName = figure.dsName
      }
      this.modelInfo.samples = figure.figurePreview.basic.value[0].records
      this.modelInfo.figureSummary = figure
      this.modelInfo.figureSummaryId = figure.figureId
      this.selectedRadio = this.isUnsModel ? null : this.modelInfo.yName
      this.figureSummary = figure
      if (!this.isUnsModel && CommonUtil.isEmpty(this.modelInfo.yName)) {
        this.modelInfo.yName = figure.yName
        this.selectedRadio = this.modelInfo.yName
      }
      this.getTrainView().$forceUpdate()
    },

    handleJoinFigureSummaryResponse (figure, newDataCollectionColumns) {
      newDataCollectionColumns.forEach(column => {
        const row = figure.figurePreview.basic.value.filter(value => value.column === column)[0]
        if (CommonUtil.isNotEmpty(row)) {
          if (CommonUtil.isNotEmpty(row.info)) {
            for (const infoCode of Object.keys(row.info)) {
              if (/^4\d{2}$/.test(infoCode)) {
                this.modelInfo.xExcept.push(row.column)
                break
              }
            }
          }
        }
      })

      this.handleFigureSummaryResponse(figure)
    },

    handleFigureDetailResponse (figure) {
      this.figureDetail = figure
      this.modelInfo.figureDetail = figure
      this.modelInfo.figureDetailId = figure.figureId
      this.visibleFigureDetail = true

      // for avoiding post figure again such as data collection is removed and post figure.
      if (this.modelInfo.ds.dsName !== figure.dsName) {
        this.modelInfo.ds.dsName = figure.dsName
        this.getTrainView().saveModelInfo()
      }
      this.$forceUpdate()
    },

    initialDataCollectionJoinPromises (notJoinedDsNames, subsetInfo) {
      if (CommonUtil.isNotEmpty(notJoinedDsNames) && CommonUtil.isNotEmpty(this.modelInfo.dataCollections)) {
        // make join promises.
        let joinParams = []
        this.modelInfo.dataCollections.forEach(data => {
          const subsets = subsetInfo.filter(
            subsets => subsets.dataCollectionId === data.dataCollectionId && subsets.categoryId ===
                data.categoryId)[0]

          let dropColumns = []
          if (CommonUtil.isNotEmpty(subsets.subset)) {
            subsets.subset.forEach(subset => {
              if (data.subsets.indexOf(subset.subsetName) === -1) {
                dropColumns = dropColumns.concat(subset.subsetColumns)
              }
            })
          }

          joinParams.push({
            dataCollectionId: data.dataCollectionId,
            categoryId: data.categoryId,
            leftOn: data.target,
            joinType: data.type,
            dropColumns: dropColumns
          })
        })

        const dataCollectionJoinParam = {
          method: this.$route.meta.trainType,
          modelId: this.modelInfo.modelId,
          joinParam: joinParams
        }

        return this.buildDataCollectionJoinPromises(notJoinedDsNames, dataCollectionJoinParam)
      } else {
        return []
      }
    },

    getModelInfoDataCollectionSubsetParams () {
      let params = []
      this.modelInfo.dataCollections.forEach(data => {
        const param = params.filter(
          param => param.dataCollectionId === data.dataCollectionId && param.categoryId === data.categoryId)[0]
        if (CommonUtil.isEmpty(param)) {
          params.push({
            dataCollectionId: data.dataCollectionId,
            categoryId: data.categoryId
          })
        }
      })

      return params
    },

    buildDataCollectionJoinParam (selectedDataCollection, selectedType, oldModelInfoDataCollection) {
      // whole data collection data need to join.
      let additionalDataCollection = selectedDataCollection
      if (CommonUtil.isNotEmpty(oldModelInfoDataCollection)) {
        additionalDataCollection = selectedDataCollection.filter(addData => {
          let result = true
          oldModelInfoDataCollection.forEach(modelData => {
            if (modelData.target === this.selectedColumn.column && modelData.dataCollectionId ===
                addData.dataCollectionId && modelData.categoryId === addData.categoryId) {
              result = false
            }
          })
          return result
        })
      }

      let joinParams = []
      additionalDataCollection.forEach(addData => {
        let dropColumns = []
        const addSubsetArrays = addData.subsets.filter(subset => subset.use === false)
        if (CommonUtil.isNotEmpty(addSubsetArrays)) {
          dropColumns = addSubsetArrays.map(subset => subset.subsetColumns)
            .reduce((array, columns) => array.concat(columns))
        }

        joinParams.push({
          dataCollectionId: addData.dataCollectionId,
          categoryId: addData.categoryId,
          leftOn: this.selectedColumn.column,
          joinType: selectedType,
          dropColumns: dropColumns
        })
      })

      // only some of Subset need to join(not whole data collection)
      let duplicateDataCollection = []
      if (CommonUtil.isNotEmpty(oldModelInfoDataCollection)) {
        duplicateDataCollection = selectedDataCollection.filter(addData => {
          let result = false
          oldModelInfoDataCollection.forEach(modelData => {
            if (modelData.target === this.selectedColumn.column && modelData.dataCollectionId ===
                addData.dataCollectionId && modelData.categoryId === addData.categoryId) {
              result = true
            }
          })
          return result
        })
      }

      // add additional subsets(already exists data collection but only subsets is changed) info to join param
      const currentColumnDataCollection = oldModelInfoDataCollection.filter(
        modelData => modelData.target === this.selectedColumn.column)
      if (CommonUtil.isNotEmpty(duplicateDataCollection)) {
        duplicateDataCollection.forEach(dupData => {
          if (CommonUtil.isNotEmpty(dupData.subsets) && dupData.subsets.filter(subset => subset.use === true).length >
              0) {
            const targetDataCollection = currentColumnDataCollection.filter(
              data => data.dataCollectionId === dupData.dataCollectionId && data.categoryId ===
                  dupData.categoryId)[0]

            let dropColumns = []
            dupData.subsets.forEach(dupDataSubset => {
              // if data collection is used, but some Subset is newly used.
              if (targetDataCollection.subsets.indexOf(dupDataSubset.subsetName) !== -1 || dupDataSubset.use ===
                  false) {
                dropColumns = dropColumns.concat(dupDataSubset.subsetColumns)
              }
            })

            // drop index column
            const dataCollectionDef = this.getDataCollectionDef(dupData.dataCollectionId, dupData.categoryId)
            dupData.xType.forEach(xType => {
              if (dataCollectionDef.indexColumns.indexOf(xType.name) !== -1) {
                dropColumns.push(xType.name)
              }
            })

            const allSubsetColumn = dupData.subsets.map(subset => subset.subsetColumns)
              .reduce((array, column) => array.concat(column))
              // if all Subset is unused, don't perform join.
            if (allSubsetColumn.filter(column => dropColumns.indexOf(column) === -1).length > 0) {
              joinParams.push({
                dataCollectionId: dupData.dataCollectionId,
                categoryId: dupData.categoryId,
                leftOn: this.selectedColumn.column,
                joinType: selectedType,
                dropColumns: dropColumns
              })
            }
          }
        })
      }
      return joinParams
    },

    buildDataCollectionJoinPromises (dsNames, joinParam, cancelable = false) {
      const source = cancelable ? axios.CancelToken.source() : null
      LoadingManager.show(this, cancelable ? 'オープンデータ収集中...' : null, source)
      let dataCollectionJoinPromises = []
      dsNames.forEach(dsName => {
        dataCollectionJoinPromises.push(
          WebApiClient.postDataCollectionJoin(this, dsName, joinParam, cancelable, source))
      })

      return Promise.all(dataCollectionJoinPromises).then((responses) => {
        LoadingManager.hide(this)
        return responses
      }
      ).catch(responses => {
        LoadingManager.hide(this)
        return Promise.reject(responses)
      })
    },

    buildDsDsDropColumnsPromises (dsNames, dropColumns) {
      let dropPromises = []
      dsNames.forEach(dsName => {
        const dropParam = {
          modelId: this.modelInfo.modelId,
          method: this.$route.meta.trainType,
          dropColumns: dropColumns
        }
        dropPromises.push(WebApiClient.postDsDropColumns(this, dsName, dropParam))
      })

      return dropPromises
    },

    handleDsDropColumnsResponses (dsNames, dropColumns, dropResults) {
      // update ds info
      this.modelInfo.ds.uploadFiles.forEach((uploadFile, i) => {
        uploadFile.dsName = dropResults[i].data.result.dsName
        uploadFile.fileName = dropResults[i].data.result.fileName
        uploadFile.fileSizeByte = dropResults[i].data.result.fileSizeByte
      })

      const ds = this.modelInfo.ds
      if (CommonUtil.isNotEmpty(ds.dsName)) {
        const targetIndex = dsNames.indexOf(ds.dsName)
        if (targetIndex !== -1) {
          this.modelInfo.ds.dsName = dropResults[targetIndex].data.result.dsName
        }
      }

      // delete from model info
      this.modelInfo.xType = this.modelInfo.xType.filter(x => dropColumns.indexOf(x.name) === -1)
      this.modelInfo.xExcept = this.modelInfo.xExcept.filter(xName => dropColumns.indexOf(xName) === -1)

      // delete from figure summary
      this.figureSummary.figurePreview.basic.value = this.figureSummary.figurePreview.basic.value.filter(
        value => dropColumns.indexOf(value.column) === -1)
      this.$forceUpdate()
    },

    revertOriginalDsInfo (deleteDataCollectionColumn = []) {
      if (CommonUtil.isEmpty(deleteDataCollectionColumn)) {
        deleteDataCollectionColumn = this.getAdditionalDataCollectionColumns()
        this.modelInfo.dataCollections = []
      }

      // update upload files info
      this.modelInfo.ds.uploadFiles.forEach(uploadFile => {
        uploadFile.dsName = uploadFile.originalDsName
        uploadFile.fileName = uploadFile.originalFileName
        uploadFile.fileSizeByte = uploadFile.originalFileSizeByte
      })
      // delete from figure summary
      this.figureSummary.figurePreview.basic.value = this.figureSummary.figurePreview.basic.value.filter(
        value => deleteDataCollectionColumn.indexOf(value.column) === -1)

      // delete from model info
      this.modelInfo.xType = this.modelInfo.xType.filter(x => deleteDataCollectionColumn.indexOf(x.name) === -1)
      this.modelInfo.xExcept = this.modelInfo.xExcept.filter(
        xName => deleteDataCollectionColumn.indexOf(xName) === -1)

      this.modelInfo.ds.dsName = null
    },

    getAllDsNames () {
      let dsNames = this.modelInfo.ds.uploadFiles.map(uploadFile => uploadFile.dsName)
      const ds = this.modelInfo.ds
      if (CommonUtil.isNotEmpty(ds.dsName)) {
        if (dsNames.indexOf(ds.dsName) === -1) {
          dsNames.push(ds.dsName)
        }
      }
      return dsNames
    },

    onSelectVisibleChange (visible) {
      // fix bug edge crash
      const isEdge = window.navigator.userAgent.includes('Edge')
      if (isEdge && !visible) {
        document.querySelectorAll('body > .el-select-dropdown.el-popper').forEach((it) => it.remove())
      }
    },

    alertError (code = '', defaultErrorMessage = 'データの紐づけに失敗しました。') {
      const message = CommonUtil.isNotEmpty(code) ? Messages.getMessage(code) : null
      MessageBox.alert(this, message || defaultErrorMessage, {
        dangerouslyUseHTMLString: true
      }).catch(() => {})

    },

    isUsableForYName (column) {
      if ((this.$route.meta.trainType !== 'update' || this.selectedRadio === column) && !this.isUnsModel) {
        const columnInfo = this.figureSummary.figurePreview.basic.value.find(value => value.column === column)
        return CommonUtil.isNotEmpty(Object.keys(columnInfo.info).filter(infoCode => infoCode === '201'))
      }

      return false
    },

    onClickTrain () {
      this.doTrain()
    },
    buildTrainParam () {
      const algorithm = Object.assign({}, this.modelInfo.algorithm)
      algorithm.algorithmId = this.getAlgorithmId(this.modelInfo.algorithm.algorithmId)

      // let stopWords = algorithm.hyperParams.filter(hyperParam => hyperParam.hyperParamId === "stop_words");
      // if (CommonUtil.isNotEmpty(stopWords)) {
      //   stopWords.forEach(param => {
      //     param.value = param.value.split(",");
      //   })
      // }

      if (this.modelInfo.algorithm.optimizeParams) {
        algorithm.hyperParams = [
          {
            hyperParamId: 'optimize_params',
            value: 1
          }, {
            hyperParamId: 'seed',
            value: 1
          }]
      } else {
        if (CommonUtil.isNotEmpty(algorithm.hyperParams)) {
          algorithm.hyperParams = algorithm.hyperParams.filter(
            (hyperParam) => hyperParam.hyperParamId !== 'update_only_model')
        }
      }

      const xExcept = this.modelInfo.xExcept.filter(value => value !== this.modelInfo.yName)
      const ds = this.modelInfo.ds

      let transformers = CommonUtil.isNotEmpty(this.modelInfo.transformerPackage)
        ? this.modelInfo.transformerPackage.transformers
        : []
      if (CommonUtil.isEmpty(transformers) && this.modelInfo.categoryId !== 'UNS') {
        transformers = this.modelInfo.transformerPackage.transformerIds.map(id => ({ transformerId: id }))
      } else {
        transformers = transformers.filter(transformer => transformer.use === true)
      }

      return {
        modelName: this.modelInfo.modelName,
        purposeId: this.modelInfo.categoryId,
        categoryId: this.getAlgorithmCategoryId(this.modelInfo.algorithm.algorithmId),
        dsName: CommonUtil.isNotEmpty(ds.dsName) ? [ds.dsName] : this.modelInfo.ds.uploadFiles.map(
          uploadFile => uploadFile.dsName),
        xType: this.modelInfo.xType,
        yName: this.modelInfo.yName,
        xExcept: xExcept,
        transformerPackageId: this.modelInfo.categoryId !== 'UNS'
          ? this.modelInfo.transformerPackage.packageId
          : null,
        transformers: transformers,
        algorithm: algorithm,
        deleteUploadFile: this.modelInfo.deleteUploadFile,
        dataCollection: {
          possibilities: this.modelInfo.possibilities,
          joinedData: this.modelInfo.dataCollections
        },
        password: ''
      }
    },
    doTrain () {
      const param = this.buildTrainParam()
      WebApiClient.postModels(this, param).then(this.handleTrainAndUpdateResponse)
    },
    handleTrainAndUpdateResponse (response) {
      const code = response.data.code
      if (code === Code.SUCCESS) {
        this.changeLocation('model-detail', {
          modelId: response.data.result.modelId
        })
      } else if (code === Code.TIMEOUT) {
        this.changeLocation('model-list')
      }
    },

    initializeForDoTrain () {
      // Initialize modelInfo.algorithm.hyperParams
      this.getAlgorithms().then(algorithmsCategories => {
        let categoryId = this.modelInfo.categoryId
        this.getAlgorithmHyperParams(categoryId, this.modelInfo.algorithm.algorithmId).then(hyperParamSummaries => {
          let hyperParams = []
          for (let hyperParamSummary of hyperParamSummaries) {
            hyperParams.push({
              hyperParamId: hyperParamSummary.hyperParamId,
              value: (['n_units_2', 'n_units_3'].indexOf(hyperParamSummary.hyperParamId) >= 0
                ? ''
                : hyperParamSummary.defaultVal)
            })
          }
          if (CommonUtil.isNotNull(this.modelInfo.algorithm.hyperParams)) {
            for (let hyperParam of this.modelInfo.algorithm.hyperParams) {
              for (let tmpHyperParam of hyperParams) {
                if (tmpHyperParam.hyperParamId === hyperParam.hyperParamId) {
                  tmpHyperParam.value = hyperParam.value
                }
              }
            }
          }
          this.modelInfo.algorithm.hyperParams = hyperParams
          this.$forceUpdate()
        })
      })
      // Initialize modelInfo.transformerPackage
      this.getTransformers().then(() => {
        if (CommonUtil.isNull(this.modelInfo.transformerPackage)) {
          return this.getDefaultTransformerPackage().then((defaultPackage) => {
            this.modelInfo.transformerPackage = defaultPackage
            if (this.modelInfo.categoryId !== 'UNS') {
              this.modelInfo.transformerPackage.transformers = defaultPackage.transformerIds.map(id => ({
                transformerId: id,
                use: true
              }))
            }
            this.$forceUpdate()
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .model-train-data-container {
    width: 100%;
    padding: 24px;
  }

  tr.no-use-column > td,
  tr > td.no-use-field {
    background-color: #ccc;
    opacity: 0.7;
  }

  .data-collection-add-button,
  .data-collection-close-button,
  .accordion-button {
    font-size: 1.2em;
    cursor: pointer;
  }

  .data-collection-index {
    cursor: pointer;
  }

  .data-collection-add-button {
    margin-top: 10px;
    color: #2456d4;
  }

  .data-collection-close-button {
    margin-top: 10px;
    color: #d8243e;
  }

  .data-collection-add-button i:hover,
  .data-collection-close-button i:hover {
    opacity: 0.7;
  }

  tr.data-collection-index > th {
    background-color: #e3ebf4;
  }

  tr.data-collection:not(.no-use-column) > td {
    background-color: #f1f5f9;
  }

  tr.data-collection > td:first-child,
  tr.data-collection-index > th:first-child {
    background-color: #ccc;
    opacity: 0.7;
  }

  .td-wrapper {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  td {
    max-width: 30rem;
  }

</style>



// WEBPACK FOOTER //
// src/views/model/train/data.vue